import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Modal } from 'bootstrap';

@Component({
	selector: 'app-tourism-events-full-drivers-add',
	templateUrl: './tourism-events-full-drivers-add.component.html',
	styleUrls: ['./tourism-events-full-drivers-add.component.css'],
})
export class TourismEventsFullDriversAddComponent {
	private type: string = null;
	driver: string = null;
	@Input() drivers: Array<any>;
	@Output() changed = new EventEmitter();

	constructor() {}

	openModal(type) {
		new Modal(document.getElementById('driverModalAdd')).show();
		this.type = type;
	}

	dialogClose(): void {
		const modal = Modal.getInstance(document.getElementById('driverModalAdd'));
		if (!modal) {
			return;
		}
		modal.hide();
	}

	submit(): void {
		this.changed.emit({
			type: this.type,
			id: this.driver,
		});
		this.dialogClose();
	}
}
